import type React from 'react';

import { sanitizeUrl } from '@xing-com/crate-people-directory-utils';

import type { PeopleChildItemFields } from '../types';
import { StyledUserName, StyledButton } from './people-child-name-link.styles';

export const PeopleChildNameLink: React.FC<PeopleChildItemFields> = ({
  name,
  toName,
  url,
}) => (
  <StyledButton to={sanitizeUrl(url)} size="small" fontWeight="regular">
    <StyledUserName>{`${name} ...`}</StyledUserName>
    <StyledUserName>{toName}</StyledUserName>
  </StyledButton>
);
